import { render, staticRenderFns } from "./ErsAccount.vue?vue&type=template&id=d3a05d64&scoped=true&"
import script from "./ErsAccount.vue?vue&type=script&lang=js&"
export * from "./ErsAccount.vue?vue&type=script&lang=js&"
import style0 from "./ErsAccount.vue?vue&type=style&index=0&id=d3a05d64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a05d64",
  null
  
)

export default component.exports